import { render, staticRenderFns } from "./CredentialsAdmin.vue?vue&type=template&id=1a5ce380"
import script from "./CredentialsAdmin.vue?vue&type=script&lang=js"
export * from "./CredentialsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports